module.exports = __webpack_public_path__ + "4b32e93b0c986f984d54c35611695349.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/ball-basketball-s.png
// module id = 2466
// module chunks = 0